'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var baseFetch = require('./baseFetch.js');

var jsonFetch = function jsonFetch(url, options) {
  options.headers = options.headers || {};
  options.headers.Accept = options.headers.Accept || 'application/json'; // NB: a 204-status would imply no body, so res.json will fails; need to manually return
  //     the empty payload

  return baseFetch.baseFetch(url, options).then(function (res) {
    return res.status === 204 ? {} : res.json();
  });
};

exports.jsonFetch = jsonFetch;
//# sourceMappingURL=jsonFetch.js.map
